











































































































































import {API} from '@/services/api/api';
import validator from '@/utils/validator';
import moment from 'moment';
import {Vue, Component, Provide, Emit, Watch, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['currentTabActionPlan'])},
})
export default class Verification extends Vue {
  @Prop({default: false}) canFetchDataFromAPI!: boolean;
  isReadOnly = false;

  isScreenLoading = false;
  currentTabActionPlan: any;
  btnLoader = false;
  verification = '';
  veriValidationMsg = '';
  verificationDate = '';
  dateValidationMsg = '';
  statusValidationMsg = '';
  commonValidationMsg = 'This field is required';
  verificationStatus = '';
  showSuccessToast: any;
  showErrorToast: any;
  inspectionId = this.$route.params.id;

  statusOptions = [
    {id: 1, name: 'Open', value: 'Open'},
    {id: 2, name: 'On Hold', value: 'On Hold'},
    {id: 3, name: 'Close', value: 'Close'},
  ];

  mounted() {
    if (this.currentTabActionPlan.child === this.currentTabActionPlan.navigateTo) this.isReadOnly = false;
    else this.isReadOnly = true;
    this.getActionPlanData();
  }
  async getActionPlanData() {
    try {
      this.isScreenLoading = true;
      let response = await API.fetchActionPlanDataByInspectionId(this.inspectionId);

      if (response.data) {
        const data = response.data;
        const verificationData = data.verification;
        this.verification = verificationData.verification;
        this.verificationDate = moment(verificationData.verificationDate).format('YYYY-MM-DD');
        this.verificationStatus = verificationData.status;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  validateVerification() {
    if (validator.isNullOrEmpty(this.verification)) {
      this.veriValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.veriValidationMsg = '';
      return true;
    }
  }

  validateDate() {
    if (validator.isNullOrEmpty(this.verificationDate)) {
      this.dateValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.dateValidationMsg = '';
      return true;
    }
  }

  validateStatus() {
    if (validator.isNullOrEmpty(this.verificationStatus)) {
      this.statusValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.statusValidationMsg = '';
      return true;
    }
  }

  validateAll() {
    return this.validateVerification() && this.validateDate() && this.validateStatus();
  }

  async onSaveClick() {
    if (this.validateAll()) {
      try {
        this.btnLoader = true;

        const params = {
          inspectionId: this.inspectionId,
          verification: {
            verification: this.verification,
            verificationDate: this.verificationDate,
            status: this.verificationStatus,
          },
        };

        const response = await API.saveActionPlanData(params);
        if (response.data) {
          this.$router.push('/inspection-list');
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);
        this.showErrorToast({msg: error});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  onCancelClick() {
    this.$router.go(-1);
  }
}
